/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("UnsortableVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class UnsortableVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.UnsortableVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.UnsortableVMBehavior.prototype */ {
      __name: "UnsortableVMBehavior",

      watchedAttributes: {
        anchor: ["unsortable"],
        parent: ["unsortableColumns"]
      },

      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const anchorNode = controller.getAnchorNode();
        const parentNode = anchorNode.getParentNode();
        controller.getWidget()?.setSortable(anchorNode.attribute("unsortable") === 0 && parentNode.attribute("unsortableColumns") === 0);
      }
    };
  });
});
